$( document ).ready(function() {



    const currentCajaId="";


    function muestraModal(texto) {
        const modal = document.getElementById("myModal");
        const span = document.getElementsByClassName("close")[0];
        const textomodal = document.getElementsByClassName("texto_modal")[0];
        textomodal.innerHTML = textomodal.getAttribute("data-".concat(texto));
        modal.style.display = "block";
        span.onclick = function cierraAlClicar() {
            modal.style.display = "none";
        };
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        };
    }


    function muestraModalCompartir(texto) {
        const modal = document.getElementById("myModalCompartir");
        const textomodal = document.getElementsByClassName("contenido_compartir")[0];
        textomodal.innerHTML = texto;
        modal.style.display = "block";
        $('.close').on('click',function(){
            modal.style.display = "none";
            muestraInfoCombinacion();
        });
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
                muestraInfoCombinacion();
            }
        };
    }

        $('.navegacion_prev').on('click',function(){
                $(".resumen_de_signos ul").slick("slickPrev");
        });

        $('.navegacion_next').on('click',function(){
                $(".resumen_de_signos ul").slick("slickNext");
        });


    $('.actua_on_change').change(function() {
        const pais=$('#pais_select').val();
        $('.provincias_select').removeClass('active');
        $(`#provincias_${pais}`).addClass('active');
        $('.tipodeboda_select ').removeClass('active');
        $(`#tipodeboda_${pais}`).addClass('active');
        calculaPresupuesto()
    });

   // $('.selector_tipo_de_boda').on('click',function(){

    function scrollParentToTop() {
        // Enviar un mensaje a la página principal para hacer scroll
        // eslint-disable-next-line no-restricted-globals
        parent.postMessage({ type: "scrollToTop" }, document.referrer);
    }

    function requestUrlParams() {
        // Enviar un mensaje a la página principal para obtener los parámetros de la URL
        // eslint-disable-next-line no-restricted-globals

        // eslint-disable-next-line no-restricted-globals
        parent.postMessage({ type: "getUrlParams" }, document.referrer);
    }


    window.addEventListener("message", function(event) {
        // Verificar el origen del mensaje para seguridad
        console.log(event);
        if (event.origin === "https://landing.bodas.net" && event.data.type === "urlParams") {
            addParamsToAllLinks(event.data.params);
        }
    }, false);


    function addParamsToUrl(url, params) {
        const urlObj = new URL(url);
        const existingParams = new URLSearchParams(urlObj.search);

        // Agregar nuevos parámetros
        // eslint-disable-next-line no-restricted-syntax
        for (const key in params) {
            // eslint-disable-next-line no-prototype-builtins
            if (params.hasOwnProperty(key)) {
                existingParams.set(key, params[key]);
            }
        }

        // Devolver la URL con los parámetros agregados
        urlObj.search = existingParams.toString();
        return urlObj.toString();
    }

    function addParamsToAllLinks(params) {
        const links = document.querySelectorAll('a');

        links.forEach(link => {
            const updatedUrl = addParamsToUrl(link.href, params);
            link.href = updatedUrl;
        });
    }

    function marcaElementoTipoBoda(elemento){
        $(".selector_tipo_de_boda").removeClass("active");
        $(".selector_tipo_de_boda").removeClass("pasado");
        $(elemento).addClass("active");
        $(elemento).prevAll().addClass("pasado");
        const pais=$('#pais_select').val();
        $(`#selector_tipodeboda_${pais}`).val($(elemento).data('value')); // Reemplaza "miSelect" con el nombre de tu select
        calculaPresupuesto();
        posicionaSlide();
    }

     $('.selector_tipo_de_boda').on('click',function(){
         marcaElementoTipoBoda($(this));
     });
    function roundToNearest500(price) {
        return Math.round(price / 500) * 500;
    }



    $('.boton_calcula').on('click',function(){

        const pais=$('#pais_select').val();
        if($(`#provincias_${pais}`).val()!=="" && $(`#selector_tipodeboda_${pais}`).val()!=="" && $(`#invitados_${pais}`).val()!=="" ){
            if (window.self !== window.top) {
                scrollParentToTop();
            }
            calculaPresupuesto();
            $('#pagina_uno').hide();
            $('#pagina_dos').show();
            $('#footer').show();
            $('body').removeClass('pagina1');


        }else{
            muestraModal('requeridos');
        }
    })


    let isDragging = false;
    let startX; let initialLeft;
    const puntoInicio=posicionPunto('1');
    const puntoFinal=posicionPunto('5');
    if (window.self !== window.top) {
        // Ejecuta tu función aquí
        requestUrlParams();
    }

    $('.draggable').on('mousedown', function(e) {
        isDragging = true;
        startX = e.clientX;
        initialLeft = $(this).position().left;

        $(document).on('mousemove', onMouseMove);
        $(document).on('mouseup', onMouseUp);
    });

    function onMouseMove(e) {
        const pais=$('#pais_select').val();
        if (!isDragging) return;
        const dx = e.clientX - startX;
        let newLeft = initialLeft + dx;

        // Restrict movement within parent bounds
        const parentWidth = $(`#tipodeboda_${pais}`).width();
        const draggableWidth = $(`#draggable_${pais}`).width();
        newLeft = Math.max(0, Math.min(newLeft, parentWidth - draggableWidth));
        if(newLeft<puntoInicio){
            newLeft=puntoInicio;
        }
        if(newLeft>puntoFinal){
            newLeft=puntoFinal;
        }
        $(`#draggable_${pais}`).css('left', `${newLeft  }px`);

        $('.punto').each(function() {
            if (isOverlapping($(`#draggable_${pais}`), $(this))) {
                marcaElementoTipoBoda($(this).parent().parent());
            }
        });
    }

    function posicionaSlide(){

        const pais=$('#pais_select').val();
        const activePoint = $(`#tipodeboda_${pais} .selector_tipo_de_boda.active .punto`);
        const activeWeddingType = $(`#tipodeboda_${pais}.tipodeboda_select`);
        if (activePoint.length) {
            const offset = activePoint.offset();
            const offsetActive=activeWeddingType.offset();
            const newLeft=offset.left-offsetActive.left;
            $(`#draggable_${pais}`).css('left', `${newLeft  }px`);
        }
    }

    function posicionPunto($id){

        const pais=$('#pais_select').val();
        const activePoint = $(`#tipodeboda_${pais} .selector_tipo_de_boda .progress_${$id} .punto`);

        const activeWeddingType = $(`#tipodeboda_${pais}.tipodeboda_select`);
        const offset = activePoint.offset();
        const offsetActive=activeWeddingType.offset();
        const newLeft=offset.left-offsetActive.left;
        return newLeft;
    }

    function onMouseUp() {
        const pais=$('#pais_select').val();
        isDragging = false;
        $(document).off('mousemove', onMouseMove);
        $(document).off('mouseup', onMouseUp);
        posicionaSlide();


    }

    function isOverlapping($div1, $div2) {
        const rect1 = $div1[0].getBoundingClientRect();
        const rect2 = $div2[0].getBoundingClientRect();
        return !(rect1.right < rect2.left ||
            rect1.left > rect2.right ||
            rect1.bottom < rect2.top ||
            rect1.top > rect2.bottom);
    }

function calculaPresupuesto(){

    const pais=$('#pais_select').val();
    const porcentajeCosteFijo=$('#pais_select  option:selected').data('porcentaje_coste_fijo');
    const porcentajeCosteVariable=$('#pais_select  option:selected').data('porcentaje_coste_variable');

    const provincia=$(`#provincias_${pais}`).val();
    const numeroInvitados=parseFloat($(`#provincias_${pais}  option:selected`).data('invitados'));
    const costeInvitados=parseFloat($(`#provincias_${pais}  option:selected`).data('costeinvitado'));
    const inflacion=parseFloat($(`#provincias_${pais}  option:selected`).data('inflacion'));
    const tipodeboda=$(`#selector_tipodeboda_${pais}`).val();
    const minTipodeboda=parseFloat($(`#selector_tipodeboda_${pais}  option:selected`).data('min'));
    const maxTipodeboda=parseFloat($(`#selector_tipodeboda_${pais}  option:selected`).data('max'));
    const invitadosUsuario=parseFloat($(`#invitados_${pais}`).val());

    const inflacionCalculada=(inflacion/100)+1;
    const costeInvitadosInflacion=costeInvitados*inflacionCalculada;
    const costeGeneral=numeroInvitados*costeInvitadosInflacion;
    const costeFijo=costeGeneral*porcentajeCosteFijo/100;
    const costeVariable=costeGeneral*porcentajeCosteVariable/100;
    const costeInvitadoCalculado=costeVariable/numeroInvitados;
    const resultado=(costeInvitadoCalculado*invitadosUsuario)+costeFijo;
    const costeMin=roundToNearest500(parseFloat(resultado*minTipodeboda/100));
    const costeMax=roundToNearest500(parseFloat(resultado*maxTipodeboda/100));
    let estiloMoneda='da-DK';
    if(pais==='4'){
        estiloMoneda='en-GB';
    }
    console.log(pais);
    const precioFormateadoMin = costeMin.toLocaleString(estiloMoneda, { style: 'currency', currency: $('#min').data('moneda'),
        minimumFractionDigits: 0});
    const precioFormateadoMax = costeMax.toLocaleString(estiloMoneda, { style: 'currency', currency: $('#min').data('moneda'),
        minimumFractionDigits: 0 });

    $('#min').html(`${precioFormateadoMin} `);
    $('#max').html(`${precioFormateadoMax} <sup>*</sup>`);
}

    posicionaSlide();

    function copyToClipboard(element) {
        const aux = document.createElement("input");
        aux.setAttribute("value", element);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        $('.copia_link').html(lang.enlace_copiado);
    }

    function saveAs(uri, filename) {
        const link = document.createElement('a');
        if (typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    }

    function capturaPantalla(){
        $('.atras').hide();
        $('.compartir').hide();
        $('.boton_combinacion').hide();

        html2canvas($("#pagina_dos")[0]).then((canvas) => {
                saveAs(canvas.toDataURL(), 'zodiac.png');
            });
        $('.atras').show();
        $('.compartir').show();
        $('.boton_combinacion').show();

    }

    $('#enviar').on('click',function(){

        modalFinal();
    })



    $('.atras').on('click',function(){
        $('#pagina_dos').removeClass('active');
        $('#pagina_uno').addClass('active');
    })
    $('.inicio').on('click',function(){
        const lang = $('#idioma').val();
        const url  = `https://weddingtools.net/zodiac/horoscopo.php?lang=${(lang)}&pais=${(lang)}`;
        // eslint-disable-next-line no-restricted-globals
        location.href=url;
    })

    function generalUrl(){
        const lang = $('#idioma').val();
        const signo1 = $('#caja_uno').data('signo');
        const signo2 = $('#caja_dos').data('signo');
        const url  = `https://weddingtools.net/zodiac/horoscopo.php?lang=${(lang)}&signo1=${(signo1)}&signo2=${(signo2)}&pais=${(lang)}`;
        return (url);
    }

    if($('#ejecutaAlIniciar').val()==='1'){
        $('.boton_combinacion').show();
        muestraInfoCombinacion();
    }

    $('.compartir').on('click',function(){
        const url=generalUrl();
        let texto='<div class="bloque_compartir">';
            texto+=`<div class="cabecera_compartir"><div class="icono_cabecera_compartir"><img src="images/compartir_popup.svg" class="img_fluid"></div>${lang.comparte_tu_resultado}</div>`;
            texto+='<div class="links_compartir">';
                texto+='<ul>';
                    texto+='<li class="whatsapp">';
                        texto+='<div class="icono_compartir"><img src="images/whats.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="whatsapp://send?text=${lang.texto_whatsapp} ${encodeURIComponent(url)}">`;
                                texto+=lang.por_whatsapp;
                                texto+='</a>';
                            texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="copy">';
                        texto+='<div class="icono_compartir"><img src="images/copy.svg" class="img_fluid"></div>';
                            texto+='<div  class="texto_compartir">';
                                texto+=`<a href="javascript:void(0);" class="copia_link">`;
                                    texto+=lang.copiar_enlace;
                                texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="download">';
                        texto+='<div class="icono_compartir"><img src="images/download.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="javascript:void(0);" class="descarga_imagen">`;
                            texto+=lang.descargar_imagen;
                            texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                texto+='</ul>';
            texto+='</div>';
        texto+='</div>';
        muestraModalCompartir(texto) ;

        $('.copia_link').on('click',function(){
            copyToClipboard(url);
        })

        $('.descarga_imagen').on('click',function(){
            capturaPantalla();
        })

    })

    function modalFinal(){
        const url=generalUrl();
        let texto='<div class="bloque_registrar">';
            texto+=`<img src="./images/${$('#idioma').val()}.png" class="logo_home img_fluid margen_centrado">`;
            texto+='<div class="logo_texto_popup">';
                texto+='<img src="./images/imagen_popup.svg" class="img_regalo img_fluid margen_centrado">';
            texto+='</div>';
            texto+='<div  class="texto_compartir">';
            texto+=lang.mensaje_popup;
            texto+='</div>';
            texto+='<div  class="boton_popup">';
                texto+=`<a href="${lang.me_apunto_url}" target="_blank"  >`;
                texto+=lang.me_apunto;
                texto+='</a>';
            texto+='</div>';

        texto+='</div>';


        muestraModalCompartir(texto) ;
    }

});
